<script lang="ts">
  import PhilatelicSetRow from "./PhilatelicSetRow.svelte"
  import SingleStampRow from "./SingleStampRow.svelte";
  import BlockRow from "./BlockRow.svelte";
  import BookletRow from "./BookletRow.svelte";
  import SeTenantsRow from "./SeTenantsRow.svelte";

  import { type PhilatelicItem, PhilatelicItemType } from "@briefmarken_katalog/types";
  import { typeIndicatorClass } from './typeColors';
  import { Pencil } from '@lucide/svelte';

  import './row.css'

  export let item: PhilatelicItem;
  export let readonly: boolean = false;
  export let onMoveToReview: (() => void) | undefined = undefined;
</script>

<div class="flex rounded-xl overflow-hidden bg-secondary item-row-contain">
  <div class="w-1.5 shrink-0 {typeIndicatorClass[item.type]}"></div>
  <div class="min-w-0 flex-1">
    {#if item.type === PhilatelicItemType.SingleStamp}
    <SingleStampRow stamp={item} {readonly}/>
    {:else if item.type === PhilatelicItemType.Set}
    <PhilatelicSetRow set={item} {readonly}/>
    {:else if item.type === PhilatelicItemType.Block}
    <BlockRow block={item} {readonly}/>
    {:else if item.type === PhilatelicItemType.Booklet}
    <BookletRow booklet={item} {readonly}/>
    {:else if item.type === PhilatelicItemType.SeTenants}
    <SeTenantsRow seTenants={item} {readonly}/>
    {/if}
  </div>
  {#if onMoveToReview}
    <button
      type="button"
      onclick={onMoveToReview}
      class="shrink-0 flex items-center px-2 text-muted-foreground hover:text-foreground transition-colors"
      title="Move to review"
    >
      <Pencil size={14} />
    </button>
  {/if}
</div>
